import { render, staticRenderFns } from "./LessonPage.vue?vue&type=template&id=550c1c7c&scoped=true"
import script from "./LessonPage.vue?vue&type=script&lang=js"
export * from "./LessonPage.vue?vue&type=script&lang=js"
import style0 from "./LessonPage.vue?vue&type=style&index=0&id=550c1c7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550c1c7c",
  null
  
)

export default component.exports